export default function Step1() {
  return (
    <div className="flex size-full flex-col items-center overflow-hidden text-center">
      <div className="size-full overflow-hidden">
        <img
          alt="image"
          src="https://storage.googleapis.com/educabot-aec-cdn-1/tich/images/explanatory-modal/step-1.png"
          className="mb-4 block max-h-full w-full max-w-full animate-fade-in overflow-hidden bg-transparent object-contain"
        />
      </div>
      <div className="w-full shrink-0 overflow-hidden">
        <p className="my-5 text-sm font-bold h-768:text-2xl">
          ¡Dejá de perder el tiempo estudiando lo que ya sabés!
        </p>
        <p className="text-sm font-normal h-768:text-xl">
          Entendemos cómo funciona tu cabeza y encontramos la manera de hackearla 😌
        </p>
      </div>
    </div>
  )
}
